import React from 'react'
import { Box, Text, useColorModeValue, Flex, IconButton } from '@chakra-ui/react'
import { LuChevronUp, LuChevronDown, LuInfo } from 'react-icons/lu'

export default function BetaBanner(props) {
  const [collapsed, setCollapsed] = React.useState(false)
  const bg = useColorModeValue('purple.50', 'rgba(255,255,255,0.04)')
  const borderColor = useColorModeValue('purple.200', 'whiteAlpha.300')
  const titleColor = useColorModeValue('purple.800', 'whiteAlpha.900')
  const bodyColor = useColorModeValue('gray.700', 'gray.200')
  const subtleBg = useColorModeValue('whiteAlpha.900', 'whiteAlpha.100')

  const toggle = () => setCollapsed((s) => !s)

  if (collapsed) {
    return (
      <Flex
        align="center"
        gap={2}
        borderRadius="lg"
        px={{ base: 3, md: 4 }}
        py={{ base: 2, md: 2 }}
        borderWidth="1px"
        borderColor={borderColor}
        bg={subtleBg}
        boxShadow="sm"
        {...props}
      >
        <LuInfo color={titleColor} />
        <Text fontWeight="bold" color={titleColor} flex="1">
          Ekkos is in early beta.
        </Text>
        <IconButton
          aria-label="Expand beta notice"
          icon={<LuChevronDown />}
          size="sm"
          variant="ghost"
          onClick={toggle}
        />
      </Flex>
    )
  }

  return (
    <Box
      borderRadius="lg"
      px={{ base: 4, md: 6 }}
      py={{ base: 3, md: 4 }}
      borderWidth="1px"
      borderColor={borderColor}
      bg={bg}
      boxShadow="sm"
      {...props}
    >
      <Flex align="start" justify="space-between" gap={3}>
        <Box>
          <Text fontWeight="bold" color={titleColor}>
            Ekkos is in early beta.
          </Text>
          <Text color={bodyColor} fontSize="sm" mt={1}>
            Things may break or behave unexpectedly. Don't use Ekkos for medical, emergency, or other
            critical reminders. Up to 5 tasks free right now for testing!
          </Text>
        </Box>
        <IconButton
          aria-label="Collapse beta notice"
          icon={<LuChevronUp />}
          size="sm"
          variant="ghost"
          onClick={toggle}
        />
      </Flex>
    </Box>
  )
}
